import { VStack, Text, StyledHtml } from "@postenbring/hedwig-react";

const formatDate = (publishDate, language) => {
    const date = new Date(publishDate);

    const dateOptions = {
        timeZone: "Europe/Oslo",
        day: "numeric",
        month: "long",
        year: "numeric"
    }
    const timeOptions = {
        timeZone: "Europe/Oslo",
        hour: "numeric",
        minute: "numeric"
    }

    const returnDate = new Intl.DateTimeFormat(language, dateOptions).format(date);
    const returnTime = new Intl.DateTimeFormat(language, timeOptions).format(date);
    return returnDate + " " + returnTime;
}

export const OperationReport = ({ heading, publishDate, language, utext }) => (
    <VStack gap="20-24">
        <Text variant="technical-title" as="time" dateTime={new Date(publishDate).toISOString()}>
            {formatDate(publishDate, language)}
        </Text>
        <Text variant="h2">{heading}</Text>
        <StyledHtml dangerouslySetInnerHTML={{ __html: utext }} />
    </VStack>
)
